import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4a40948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resolve-container" }

import ResolveMain from '@/views/resolve/ResolveMain.vue'
import ResolveList from '@/views/resolve/ResolveList.vue'
import { computed, ref } from 'vue'
import store from '@/store'
import { Pane, Splitpanes } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const creator = computed(() => {
  return store.getters.userInfo?.id || 0
})

const selectedResolveData = ref(null)
const activeTab = ref('latest') // 默认选中的标签页

const handleResolveItemClicked = (resolveData) => {
  selectedResolveData.value = resolveData
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Splitpanes), { class: "default-theme" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Pane), {
          class: "left-pane",
          "max-size": "80",
          size: "50"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
              type: "border-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "最新解析",
                  name: "latest"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ResolveList, {
                      creator: 0,
                      title: "最新解析",
                      onResolveItemClicked: handleResolveItemClicked
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "我的解析",
                  name: "mine"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ResolveList, {
                      creator: creator.value,
                      title: "我的解析",
                      onResolveItemClicked: handleResolveItemClicked
                    }, null, 8, ["creator"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Pane), { class: "right-pane" }, {
          default: _withCtx(() => [
            _createVNode(ResolveMain, { selectedResolveData: selectedResolveData.value }, null, 8, ["selectedResolveData"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})